import React from 'react';

import { Checkbox } from 'components/checkbox/Checkbox';
import { ExternalLinks } from 'externalLinks';
import { Branding } from 'common/env';

export interface SmsOptInCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const SmsOptInCheckbox = ({ checked, onChange }: SmsOptInCheckboxProps) => (
    <Checkbox
        id="smsOptedIn"
        checked={checked}
        onChange={onChange}
        className="font-normal mt-5 text-sm !items-start"
        labelClassName="text-grey-darkest"
        text={
            <span>
                By entering your phone number, you are agreeing to receive text messages from{' '}
                {Branding} related to your fundraising program set up, reminders, updates and/or
                alerts. Message &amp; data rates may apply. Message frequency may vary. Reply HELP
                for more information. You can reply STOP or UNSUBSCRIBE to opt-out. See our{' '}
                <a
                    href={ExternalLinks.PrivacyPolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand underline"
                >
                    Privacy Policy
                </a>{' '}
                for additional details.
            </span>
        }
    />
);
